import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AttributePolymorphComponent } from './attribute-polymorph.component';
import { SortPipe } from '../sort-pipe/sort.pipe';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forRoot(),
    ],
    declarations: [
        AttributePolymorphComponent,

        SortPipe
    ],
    exports: [
        AttributePolymorphComponent
    ],
    providers: []
})
export class AttributeModule { }
